export default __webpack_public_path__ + "static/media/legalpal.1389b716.png";